module.exports = __webpack_public_path__ + "static/media/quenia.d8f5408b.jpg";